import { useEffect, useMemo, useState } from "react";
import CustomFormatDatePicker from "../../../components/common/CustomFormatDatePicker";
import { useTheme } from "../../../components/hooks/useTheme";
import useConfirm from "../../../components/hooks/useConfirm";
import { branchTimezone } from "../../../utils/summaryCalculation";
import moment from "moment";
import { CurrentType } from "../../../enum/CurrentType";
import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { getLoctionOpenHours } from "../../../services/locationOpenHour";
import axios from "axios";
import baseURL from "../../../configs/api";
import { format } from "date-fns";
import colorConfigs from "../../../configs/colorConfigs";
import { getCarsWithReservation, getTheAvailableCarsOFBranch } from "../../../services/availableCars";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";
import useGeneral from "../../../components/hooks/useGeneral";

type DatesProps = {
  goToNextPage: (page: number) => void;
  getDataFromDate: (
    pickupDate: string,
    pickupTime: string,
    returnDate: string,
    returnTime: string,
    alertMessage: string,
    branchId: number,
    pickupLocation: number,
    returnLocation: number,
    walkInCustomer: boolean
  ) => void;
  preferredDateFormat?: string;
  branches: any[];
  locations: any[];
  popUpPickupDate: string;
  popUpReturnDate: string;
  popUpPickupTime: string;
  popUpReturnTime: string;
  selectBranchId: number;
  currentType: CurrentType;
  _pickupLocationId: number;
  _returnLocationId: number;
  _walkInCustomer: boolean;
  pickupLocationOptionsOfParticularBranch: any[];
  setPickupLocationOptionsOfParticularBranch: (value: any[]) => void;
  returnLocationOptionsOfParticularBranch: any[];
  setReturnLocationOptionsOfParticularBranch: (value: any[]) => void;
  locationOpenHourOfParticularBranch: any[];
  setLocationOpenHourOfParticularBranch: (value: any[]) => void;
  setLocationFeeAmount: (value: number) => void;
  setTaxAmount: (value: number) => void;
  setMandatoryAdditionalChargesAmount: (value: number) => void;
  setGovernmentTaxAmount: (value: number) => void;
  formattedCreatedAt: string;
  setFormattedCreatedAt: (value: string) => void;
  timezoneOptions: any[];
  selectedVehicleClassId: number;
  setVehicleClassId: (value: number) => void;
  setSelectedVehiclesClass: (value: any) => void;
  setAvailableVehicle: (value: any[]) => void;
  reservationId: number;
  setPleaseWait: (value: boolean) => void;
}

export const Dates = ({
  goToNextPage,
  getDataFromDate,
  preferredDateFormat,
  branches,
  locations,
  popUpPickupDate,
  popUpReturnDate,
  popUpPickupTime,
  popUpReturnTime,
  selectBranchId,
  currentType,
  _pickupLocationId,
  _returnLocationId,
  _walkInCustomer,
  pickupLocationOptionsOfParticularBranch,
  setPickupLocationOptionsOfParticularBranch,
  returnLocationOptionsOfParticularBranch,
  setReturnLocationOptionsOfParticularBranch,
  locationOpenHourOfParticularBranch,
  setLocationOpenHourOfParticularBranch,
  setLocationFeeAmount,
  setTaxAmount,
  setMandatoryAdditionalChargesAmount,
  setGovernmentTaxAmount,
  formattedCreatedAt,
  setFormattedCreatedAt,
  timezoneOptions,
  selectedVehicleClassId,
  setVehicleClassId,
  setSelectedVehiclesClass,
  setAvailableVehicle,
  reservationId,
  setPleaseWait
}: DatesProps) => {
  const { handleTenantError }: any = useTenant();
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { themeStyles } = useTheme();
  const { dateFormat }: any = useGeneral();
  const finalDateFormat = preferredDateFormat || dateFormat;
  const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
  const [pickupDate, setPickupDate] = useState<string>("");
  const [pickupTime, setPickupTime] = useState<string>("");
  const [returnDate, setReturnDate] = useState<string>("");
  const [returnTime, setReturnTime] = useState<string>("");
  const [branchId, setBranchId] = useState<number>(0);
  const [pickupLocationId, setPickupLocationId] = useState<number>(0);
  const [returnLocationId, setReturnLocationId] = useState<number>(0);
  const [walkInCustomer, setWalkInCustomer] = useState<boolean>(true);
  const [branchs, setBranchs] = useState<any[]>([]);
  const [pickupLocationOptions, setPickupLocationOptions] = useState<any[]>([]);
  const [returnLocationOptions, setReturnLocationOptions] = useState<any[]>([]);
  const [locationOpenHour, setLocationOpenHour] = useState<any[]>([]);
  const [returnTimeMessage, setreturnTimeMessage] = useState<string>("");
  const [minBookingMessage, setMinBookingMessage] = useState<string>("");
  const [isGreater, setIsGreater] = useState<boolean>(false);

  const UpdateTimezone = branchTimezone(formattedCreatedAt);

  useEffect(() => {
    if (selectBranchId > 0 && locationOpenHour?.length === 0) {
      getLoctionOpenHours(tenantId)
        .then(data => {
          setLocationOpenHour(data);
          setLocationOpenHourOfParticularBranch(data?.filter((item: any) => item.branchId === selectBranchId && (new Date(item.startDate) <= new Date() && new Date(item.endDate) >= new Date())));
          handleTenantError(null);
        })
        .catch((error) => {
          setLocationOpenHour([]);
          setLocationOpenHourOfParticularBranch([]);
          handleTenantError(error);
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectBranchId]);

  useEffect(() => {
    if (locationOpenHourOfParticularBranch.length !== 0 && currentType === CurrentType.ADD) {
      setTimeWithOpenHour(new Date(pickupDate ? pickupDate : popUpPickupDate), true);
      setTimeWithOpenHour(new Date(returnDate ? returnDate : popUpReturnDate), false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationOpenHourOfParticularBranch])

  const setTimeWithOpenHour = (date: Date, isPickupTime: boolean) => {
    const currentTime = new Date(UpdateTimezone);

    switch (date.getDay()) {
      case 0:
        if (locationOpenHourOfParticularBranch[0]?.sundayOpenTime) {
          if (isPickupTime) {
            if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.sundayOpenTime, 'HH:mm'))) {
              setPickupTime(locationOpenHourOfParticularBranch[0]?.sundayOpenTime);
            }
          } else {
            setReturnTime(locationOpenHourOfParticularBranch[0]?.sundayOpenTime);
          }
        }
        break;
      case 1:
        if (locationOpenHourOfParticularBranch[0]?.mondayOpenTime) {
          if (isPickupTime) {
            if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.mondayOpenTime, 'HH:mm'))) {
              setPickupTime(locationOpenHourOfParticularBranch[0]?.mondayOpenTime);
            }
          } else {
            setReturnTime(locationOpenHourOfParticularBranch[0]?.mondayOpenTime);
          }
        }
        break;
      case 2:
        if (locationOpenHourOfParticularBranch[0]?.tuesdayOpenTime) {
          if (isPickupTime) {
            if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.tuesdayOpenTime, 'HH:mm'))) {
              setPickupTime(locationOpenHourOfParticularBranch[0]?.tuesdayOpenTime);
            }
          } else {
            setReturnTime(locationOpenHourOfParticularBranch[0]?.tuesdayOpenTime);
          }
        }
        break;
      case 3:
        if (locationOpenHourOfParticularBranch[0]?.wednesdayOpenTime) {
          if (isPickupTime) {
            if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.wednesdayOpenTime, 'HH:mm'))) {
              setPickupTime(locationOpenHourOfParticularBranch[0]?.wednesdayOpenTime);
            }
          } else {
            setReturnTime(locationOpenHourOfParticularBranch[0]?.wednesdayOpenTime);
          }
        }
        break;
      case 4:
        if (locationOpenHourOfParticularBranch[0]?.thursdayOpenTime) {
          if (isPickupTime) {
            if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.thursdayOpenTime, 'HH:mm'))) {
              setPickupTime(locationOpenHourOfParticularBranch[0]?.thursdayOpenTime);
            }
          } else {
            setReturnTime(locationOpenHourOfParticularBranch[0]?.thursdayOpenTime);
          }
        }
        break;
      case 5:
        if (locationOpenHourOfParticularBranch[0]?.fridayOpenTime) {
          if (isPickupTime) {
            if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.fridayOpenTime, 'HH:mm'))) {
              setPickupTime(locationOpenHourOfParticularBranch[0]?.fridayOpenTime);
            }
          } else {
            setReturnTime(locationOpenHourOfParticularBranch[0]?.fridayOpenTime);
          }
        }
        break;
      case 6:
        if (locationOpenHourOfParticularBranch[0]?.saturdayOpenTime) {
          if (isPickupTime) {
            if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.saturdayOpenTime, 'HH:mm'))) {
              setPickupTime(locationOpenHourOfParticularBranch[0]?.saturdayOpenTime);
            }
          } else {
            setReturnTime(locationOpenHourOfParticularBranch[0]?.saturdayOpenTime);
          }
        }
        break;
    }
  }

  useEffect(() => {
    if (branches) {
      setBranchs(
        branches.map((item: any) => {
          return {
            value: item.id,
            label: item.branchName,
            locationId: item.defaultLocationId,
          };
        })
      );

      if (currentType === CurrentType.ADD) {
        setPickupLocationId(() => branches[0]?.defaultLocationId);
        setReturnLocationId(() => branches[0]?.defaultLocationId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branches]);

  useEffect(() => {
    if (locations) {
      setPickupLocationOptions(
        locations?.map((item: any) => {
          return {
            value: item.id,
            label: item.locationName,
            branchId: item.branchId,
            locationFeeLabel: item?.locationFeeLabel,
            locationFee: item?.locationFee,
            taxLabel: item?.taxLabel,
            tax: item?.tax,
            mandatoryAdditionalCharges: item?.mandatoryAdditionalCharges,
            governmentTax: item?.governmentTax
          };
        })
      );

      setReturnLocationOptions(
        locations?.map((item: any) => {
          return {
            value: item.id,
            label: item.locationName,
            branchId: item.branchId,
            locationFeeLabel: item?.locationFeeLabel,
            locationFee: item?.locationFee,
            taxLabel: item?.taxLabel,
            tax: item?.tax,
            mandatoryAdditionalCharges: item?.mandatoryAdditionalCharges,
            governmentTax: item?.governmentTax
          };
        })
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locations]);

  useEffect(() => {
    if (branchId > 0 && pickupLocationOptions?.length > 0) {
      setPickupLocationOptionsOfParticularBranch(pickupLocationOptions?.filter((item: any) => item.branchId === branchId));
    } else {
      setPickupLocationOptionsOfParticularBranch([]);
    }

    if (branchId > 0 && returnLocationOptions?.length > 0) {
      setReturnLocationOptionsOfParticularBranch(returnLocationOptions?.filter((item: any) => item.branchId === branchId));
    } else {
      setReturnLocationOptionsOfParticularBranch([]);
    }

    if (branchId > 0 && locationOpenHour?.length > 0) {
      setLocationOpenHourOfParticularBranch(locationOpenHour?.filter((item: any) => item.branchId === branchId && (new Date(item.startDate) <= new Date() && new Date(item.endDate) >= new Date())));
    } else {
      setLocationOpenHourOfParticularBranch([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchId, pickupLocationOptions, returnLocationOptions, locationOpenHour]);

  useEffect(() => {
    if (currentType === CurrentType.ADD) {
      let selectedBranchLocation = null;

      if (pickupLocationOptionsOfParticularBranch?.length > 0) {
        selectedBranchLocation = pickupLocationOptionsOfParticularBranch[0];
      }

      if (selectedBranchLocation) {
        setPickupLocationId(selectedBranchLocation?.value);
        setReturnLocationId(selectedBranchLocation?.value);

        setLocationFeeAmount(selectedBranchLocation?.locationFee);
        setTaxAmount(selectedBranchLocation?.tax);
        setMandatoryAdditionalChargesAmount(selectedBranchLocation?.mandatoryAdditionalCharges);
        setGovernmentTaxAmount(selectedBranchLocation?.governmentTax);
      } else {
        setPickupLocationId(0);
        setReturnLocationId(0);

        setLocationFeeAmount(0);
        setTaxAmount(0);
        setMandatoryAdditionalChargesAmount(0);
        setGovernmentTaxAmount(0);
      }
    } else if (currentType === CurrentType.EDIT) {
      if (branchId === selectBranchId) {
        setPickupLocationId(_pickupLocationId);
        setReturnLocationId(_returnLocationId);
        setWalkInCustomer(_walkInCustomer);
      }
    } else if (currentType === CurrentType.ADD_FROM_QUOTES) {
      setPickupLocationId(_pickupLocationId);
      setReturnLocationId(_returnLocationId);

      const selectedBranchLocation = pickupLocationOptionsOfParticularBranch?.find((item: any) => item?.value === _pickupLocationId);

      if (selectedBranchLocation) {
        setLocationFeeAmount(selectedBranchLocation?.locationFee);
        setTaxAmount(selectedBranchLocation?.tax);
        setMandatoryAdditionalChargesAmount(selectedBranchLocation?.mandatoryAdditionalCharges);
        setGovernmentTaxAmount(selectedBranchLocation?.governmentTax);
      } else {
        setLocationFeeAmount(0);
        setTaxAmount(0);
        setMandatoryAdditionalChargesAmount(0);
        setGovernmentTaxAmount(0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pickupLocationOptionsOfParticularBranch])

  useEffect(() => {
    if (new Date(pickupDate)?.getTime() === new Date(returnDate)?.getTime() && returnTime <= pickupTime) {
      setIsGreater(true);
      setreturnTimeMessage("Return Time must greater than pickup Time");
    }
    else {
      setIsGreater(false);
      setreturnTimeMessage("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pickupDate, pickupTime, returnDate, returnTime]);

  const selectedBranch = useMemo(() => {
    return branches?.find((branch) => branch.id === branchId);
  }, [branchId, branches]);

  const minAllowedHoursToBook = selectedBranch ? selectedBranch?.minAllowedHoursToBook : 0;

  useEffect(() => {
    const pickupDateTime = new Date(`${pickupDate}T${pickupTime}`);
    const returnDateTime = new Date(`${returnDate}T${returnTime}`);

    const timeDifferenceInMs = returnDateTime.getTime() - pickupDateTime.getTime();
    const timeDifferenceInHours = timeDifferenceInMs / (1000 * 60 * 60);

    if (new Date(pickupDate).getTime() === new Date(returnDate).getTime()) {
      if (timeDifferenceInHours < minAllowedHoursToBook) {
        setMinBookingMessage(
          `The minimum booking duration is ${minAllowedHoursToBook} hours.`
        );
        setIsGreater(true);
      } else {
        setMinBookingMessage("");
        setIsGreater(false);
      }
    } else {
      setMinBookingMessage("");
      setIsGreater(false);
    }
  }, [pickupDate, pickupTime, returnDate, returnTime, minAllowedHoursToBook]);

  useEffect(() => {
    setPickupDate(() => popUpPickupDate);
  }, [popUpPickupDate])

  useEffect(() => {
    setReturnDate(() => popUpReturnDate);
  }, [popUpReturnDate])

  useEffect(() => {
    setPickupTime(() => popUpPickupTime);
  }, [popUpPickupTime])

  useEffect(() => {
    setReturnTime(() => popUpReturnTime);
  }, [popUpReturnTime])

  useEffect(() => {
    setBranchId(() => selectBranchId);
  }, [selectBranchId])

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (
      new Date(locationOpenHourOfParticularBranch[0]?.startDate) <=
      new Date(pickupDate.replaceAll("-", "/")) &&
      new Date(locationOpenHourOfParticularBranch[0]?.endDate) >=
      new Date(returnDate.replaceAll("-", "/"))
    ) {
      if (!isGreater) {
        const pickupDateTime = moment(`${pickupDate}T${pickupTime}`).format('YYYY-MM-DDTHH:mm');
        const returnDateTime = moment(`${returnDate}T${returnTime}`).format('YYYY-MM-DDTHH:mm');
        axios.get(`${baseURL}blockedDay/GetBlockedDaysByStartDateAndEndDate/${pickupDateTime},${returnDateTime}`, {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
          }
        })
          .then((res) => {
            if (res.data.length > 0) {
              if (res.data[0]?.isAllDay) {
                setConfirmData({
                  title: `We are closed on ${format(new Date(res.data[0]?.startDate.split('T')[0]), finalDateFormat.replace('DD', 'dd')) === format(new Date(pickupDate), finalDateFormat.replace('DD', 'dd')) ?
                    format(new Date(pickupDate), finalDateFormat.replace('DD', 'dd'))
                    :
                    format(new Date(res.data[0]?.startDate.split('T')[0]), finalDateFormat.replace('DD', 'dd')) === format(new Date(returnDate), finalDateFormat.replace('DD', 'dd')) ?
                      format(new Date(returnDate), finalDateFormat.replace('DD', 'dd'))
                      :
                      format(new Date(pickupDate), finalDateFormat.replace('DD', 'dd'))
                    }`,
                  summary: 'Are you sure you want to proceed?',
                  isConfirm: (callback: any) => {
                    const alerMessage = `We are closed on ${format(new Date(res.data[0]?.startDate.split('T')[0]), finalDateFormat.replace('DD', 'dd')) === format(new Date(pickupDate), finalDateFormat.replace('DD', 'dd')) ?
                      format(new Date(pickupDate), finalDateFormat.replace('DD', 'dd'))
                      :
                      format(new Date(res.data[0]?.startDate.split('T')[0]), finalDateFormat.replace('DD', 'dd')) === format(new Date(returnDate), finalDateFormat.replace('DD', 'dd')) ?
                        format(new Date(returnDate), finalDateFormat.replace('DD', 'dd'))
                        :
                        format(new Date(pickupDate), finalDateFormat.replace('DD', 'dd'))
                      }`
                    changeTheDate(alerMessage, callback);
                  }
                });
                setConfirmPopup(true);
              } else {
                setConfirmData({
                  title: `We are closed on ${format(new Date(res.data[0]?.startDate.split('T')[0]), finalDateFormat.replace('DD', 'dd')) === format(new Date(pickupDate), finalDateFormat.replace('DD', 'dd')) ?
                    format(new Date(pickupDate), finalDateFormat.replace('DD', 'dd'))
                    :
                    format(new Date(res.data[0]?.startDate.split('T')[0]), finalDateFormat.replace('DD', 'dd')) === format(new Date(returnDate), finalDateFormat.replace('DD', 'dd')) ?
                      format(new Date(returnDate), finalDateFormat.replace('DD', 'dd'))
                      :
                      ""
                    } between ${format(new Date(res.data[0]?.startDate.split('T')[0] + "T" + res.data[0]?.startTime), "hh:mm aaaaa'm'")} to ${format(new Date(res.data[0]?.startDate.split('T')[0] + "T" + res.data[0]?.endTIme), "hh:mm aaaaa'm'")}`,
                  summary: 'Are you sure you want to proceed?',
                  isConfirm: (callback: any) => {
                    const alerMessage = `We are closed on ${format(new Date(res.data[0]?.startDate.split('T')[0]), finalDateFormat.replace('DD', 'dd')) === format(new Date(pickupDate), finalDateFormat.replace('DD', 'dd')) ?
                      format(new Date(pickupDate), finalDateFormat.replace('DD', 'dd'))
                      :
                      format(new Date(res.data[0]?.startDate.split('T')[0]), finalDateFormat.replace('DD', 'dd')) === format(new Date(returnDate), finalDateFormat.replace('DD', 'dd')) ?
                        format(new Date(returnDate), finalDateFormat.replace('DD', 'dd'))
                        :
                        ""
                      } between ${format(new Date(res.data[0]?.startDate.split('T')[0] + "T" + res.data[0]?.startTime), "hh:mm aaaaa'm'")} to ${format(new Date(res.data[0]?.startDate.split('T')[0] + "T" + res.data[0]?.endTIme), "hh:mm aaaaa'm'")}`;

                    changeTheDate(alerMessage, callback);
                  }
                });
                setConfirmPopup(true);
              }
            } else {
              let pickupDateMessages = "";
              let returnDateMessages = "";
              let pickupTimeMessages = "";
              let returnTimeMessages = "";
              switch (new Date(pickupDate.replaceAll("-", "/")).getDay()) {
                case 0:
                  if (locationOpenHourOfParticularBranch[0].isSundayOpen) {
                    pickupDateMessages = "";
                    if (
                      locationOpenHourOfParticularBranch[0].sundayOpenTime <=
                      pickupTime &&
                      locationOpenHourOfParticularBranch[0].sundayCloseTime >=
                      pickupTime
                    ) {
                      pickupTimeMessages = "";
                    } else {
                      pickupTimeMessages =
                        "Office on Sunday is open from " +
                        moment(locationOpenHourOfParticularBranch[0].sundayOpenTime, "HH:mm").format("hh:mm a") +
                        " to " +
                        moment(locationOpenHourOfParticularBranch[0].sundayCloseTime, "HH:mm").format("hh:mm a");
                    }
                  } else {
                    pickupDateMessages = "Office is closed on Sunday";
                  }
                  break;
                case 1:
                  if (locationOpenHourOfParticularBranch[0].isMondayOpen) {
                    pickupDateMessages = "";
                    if (
                      locationOpenHourOfParticularBranch[0].mondayOpenTime <=
                      pickupTime &&
                      locationOpenHourOfParticularBranch[0].mondayCloseTime >=
                      pickupTime
                    ) {
                      pickupTimeMessages = "";
                    } else {
                      pickupTimeMessages = "Office on Monday is open from " +
                        moment(locationOpenHourOfParticularBranch[0].mondayOpenTime, "HH:mm").format("hh:mm a") +
                        " to " +
                        moment(locationOpenHourOfParticularBranch[0].mondayCloseTime, "HH:mm").format("hh:mm a");
                    }
                  } else {
                    pickupDateMessages = "Office is closed on Monday";
                  }
                  break;
                case 2:
                  if (locationOpenHourOfParticularBranch[0].isTuesdayOpen) {
                    pickupDateMessages = "";
                    if (
                      locationOpenHourOfParticularBranch[0].tuesdayOpenTime <=
                      pickupTime &&
                      locationOpenHourOfParticularBranch[0].tuesdayCloseTime >=
                      pickupTime
                    ) {
                      pickupTimeMessages = "";
                    } else {
                      pickupTimeMessages =
                        "Office on Tuesday is open from " +
                        moment(locationOpenHourOfParticularBranch[0].tuesdayOpenTime, "HH:mm").format("hh:mm a") +
                        " to " +
                        moment(locationOpenHourOfParticularBranch[0].tuesdayCloseTime, "HH:mm").format("hh:mm a");
                    }
                  } else {
                    pickupDateMessages = "Office is closed on Tuesday";
                  }
                  break;
                case 3:
                  if (locationOpenHourOfParticularBranch[0].isWednesdayOpen) {
                    pickupDateMessages = "";
                    if (
                      locationOpenHourOfParticularBranch[0].wednesdayOpenTime <=
                      pickupTime &&
                      locationOpenHourOfParticularBranch[0].wednesdayCloseTime >=
                      pickupTime
                    ) {
                      pickupTimeMessages = "";
                    } else {
                      pickupTimeMessages =
                        "Office on Wednesday is open from " +
                        moment(locationOpenHourOfParticularBranch[0].wednesdayOpenTime, "HH:mm").format("hh:mm a") +
                        " to " +
                        moment(locationOpenHourOfParticularBranch[0].wednesdayCloseTime, "HH:mm").format("hh:mm a");
                    }
                  } else {
                    pickupDateMessages = "Office is closed on Wednesday";
                  }
                  break;
                case 4:
                  if (locationOpenHourOfParticularBranch[0].isThursdayOpen) {
                    pickupDateMessages = "";
                    if (
                      locationOpenHourOfParticularBranch[0].thursdayOpenTime <=
                      pickupTime &&
                      locationOpenHourOfParticularBranch[0].thursdayCloseTime >=
                      pickupTime
                    ) {
                      pickupTimeMessages = "";
                    } else {
                      pickupTimeMessages =
                        "Office on Thursday is open from " +
                        moment(locationOpenHourOfParticularBranch[0].thursdayOpenTime, "HH:mm").format("hh:mm a") +
                        " to " +
                        moment(locationOpenHourOfParticularBranch[0].thursdayCloseTime, "HH:mm").format("hh:mm a");
                    }
                  } else {
                    pickupDateMessages = "Office is closed on Thursday";
                  }
                  break;
                case 5:
                  if (locationOpenHourOfParticularBranch[0].isFridayOpen) {
                    pickupDateMessages = "";
                    if (
                      locationOpenHourOfParticularBranch[0].fridayOpenTime <=
                      pickupTime &&
                      locationOpenHourOfParticularBranch[0].fridayCloseTime >=
                      pickupTime
                    ) {
                      pickupTimeMessages = "";
                    } else {
                      pickupTimeMessages =
                        "Office on Friday is open from " +
                        moment(locationOpenHourOfParticularBranch[0].fridayOpenTime, "HH:mm").format("hh:mm a") +
                        " to " +
                        moment(locationOpenHourOfParticularBranch[0].fridayCloseTime, "HH:mm").format("hh:mm a");
                    }
                  } else {
                    pickupDateMessages = "Office is closed on Friday";
                  }
                  break;
                case 6:
                  if (locationOpenHourOfParticularBranch[0].isSaturdayOpen) {
                    pickupDateMessages = "";
                    if (
                      locationOpenHourOfParticularBranch[0].saturdayOpenTime <=
                      pickupTime &&
                      locationOpenHourOfParticularBranch[0].saturdayCloseTime >=
                      pickupTime
                    ) {
                      pickupTimeMessages = "";
                    } else {
                      pickupTimeMessages =
                        "Office on Saturday is open from " +
                        moment(locationOpenHourOfParticularBranch[0].saturdayOpenTime, "HH:mm").format("hh:mm a") +
                        " to " +
                        moment(locationOpenHourOfParticularBranch[0].saturdayCloseTime, "HH:mm").format("hh:mm a");
                    }
                  } else {
                    pickupDateMessages = "Office is closed on Saturday";
                  }
                  break;
              }

              switch (new Date(returnDate.replaceAll("-", "/")).getDay()) {
                case 0:
                  if (locationOpenHourOfParticularBranch[0].isSundayOpen) {
                    returnDateMessages = "";
                    if (
                      locationOpenHourOfParticularBranch[0].sundayOpenTime <=
                      returnTime &&
                      locationOpenHourOfParticularBranch[0].sundayCloseTime >=
                      returnTime
                    ) {
                      returnTimeMessages = "";
                    } else {
                      returnTimeMessages =
                        "Office on Sunday is open from " +
                        moment(locationOpenHourOfParticularBranch[0].sundayOpenTime, "HH:mm").format("hh:mm a") +
                        " to " +
                        moment(locationOpenHourOfParticularBranch[0].sundayCloseTime, "HH:mm").format("hh:mm a");
                    }
                  } else {
                    returnDateMessages = "Office is closed on Sunday";
                  }
                  break;
                case 1:
                  if (locationOpenHourOfParticularBranch[0].isMondayOpen) {
                    returnDateMessages = "";
                    if (
                      locationOpenHourOfParticularBranch[0].mondayOpenTime <=
                      returnTime &&
                      locationOpenHourOfParticularBranch[0].mondayCloseTime >=
                      returnTime
                    ) {
                      returnTimeMessages = "";
                    } else {
                      returnTimeMessages =
                        "Office on Monday is open from " +
                        moment(locationOpenHourOfParticularBranch[0].mondayOpenTime, "HH:mm").format("hh:mm a") +
                        " to " +
                        moment(locationOpenHourOfParticularBranch[0].mondayCloseTime, "HH:mm").format("hh:mm a");
                    }
                  } else {
                    returnDateMessages = "Office is closed on Monday";
                  }
                  break;
                case 2:
                  if (locationOpenHourOfParticularBranch[0].isTuesdayOpen) {
                    returnDateMessages = "";
                    if (
                      locationOpenHourOfParticularBranch[0].tuesdayOpenTime <=
                      returnTime &&
                      locationOpenHourOfParticularBranch[0].tuesdayCloseTime >=
                      returnTime
                    ) {
                      returnTimeMessages = "";
                    } else {
                      returnTimeMessages =
                        "Office on Tuesday is open from " +
                        moment(locationOpenHourOfParticularBranch[0].tuesdayOpenTime, "HH:mm").format("hh:mm a") +
                        " to " +
                        moment(locationOpenHourOfParticularBranch[0].tuesdayCloseTime, "HH:mm").format("hh:mm a");
                    }
                  } else {
                    returnDateMessages = "Office is closed on Tuesday";
                  }
                  break;
                case 3:
                  if (locationOpenHourOfParticularBranch[0].isWednesdayOpen) {
                    returnDateMessages = "";
                    if (
                      locationOpenHourOfParticularBranch[0].wednesdayOpenTime <=
                      returnTime &&
                      locationOpenHourOfParticularBranch[0].wednesdayCloseTime >=
                      returnTime
                    ) {
                      returnTimeMessages = "";
                    } else {
                      returnTimeMessages =
                        "Office on Wednesday is open from " +
                        moment(locationOpenHourOfParticularBranch[0].wednesdayOpenTime, "HH:mm").format("hh:mm a") +
                        " to " +
                        moment(locationOpenHourOfParticularBranch[0].wednesdayCloseTime, "HH:mm").format("hh:mm a");
                    }
                  } else {
                    returnDateMessages = "Office is closed on Wednesday";
                  }
                  break;
                case 4:
                  if (locationOpenHourOfParticularBranch[0].isThursdayOpen) {
                    returnDateMessages = "";
                    if (
                      locationOpenHourOfParticularBranch[0].thursdayOpenTime <=
                      returnTime &&
                      locationOpenHourOfParticularBranch[0].thursdayCloseTime >=
                      returnTime
                    ) {
                      returnTimeMessages = "";
                    } else {
                      returnTimeMessages =
                        "Office on Thursday is open from " +
                        moment(locationOpenHourOfParticularBranch[0].thursdayOpenTime, "HH:mm").format("hh:mm a") +
                        " to " +
                        moment(locationOpenHourOfParticularBranch[0].thursdayCloseTime, "HH:mm").format("hh:mm a");
                    }
                  } else {
                    returnDateMessages = "Office is closed on Thursday";
                  }
                  break;
                case 5:
                  if (locationOpenHourOfParticularBranch[0].isFridayOpen) {
                    returnDateMessages = "";
                    if (
                      locationOpenHourOfParticularBranch[0].fridayOpenTime <=
                      returnTime &&
                      locationOpenHourOfParticularBranch[0].fridayCloseTime >=
                      returnTime
                    ) {
                      returnTimeMessages = "";
                    } else {
                      returnTimeMessages =
                        "Office on Friday is open from " +
                        moment(locationOpenHourOfParticularBranch[0].fridayOpenTime, "HH:mm").format("hh:mm a") +
                        " to " +
                        moment(locationOpenHourOfParticularBranch[0].fridayCloseTime, "HH:mm").format("hh:mm a");
                    }
                  } else {
                    returnDateMessages = "Office is closed on Friday";
                  }
                  break;
                case 6:
                  if (locationOpenHourOfParticularBranch[0].isSaturdayOpen) {
                    returnDateMessages = "";
                    if (
                      locationOpenHourOfParticularBranch[0].saturdayOpenTime <=
                      returnTime &&
                      locationOpenHourOfParticularBranch[0].saturdayCloseTime >=
                      returnTime
                    ) {
                      returnTimeMessages = "";
                    } else {
                      returnTimeMessages =
                        "Office on Saturday is open from " +
                        moment(locationOpenHourOfParticularBranch[0].saturdayOpenTime, "HH:mm").format("hh:mm a") +
                        " to " +
                        moment(locationOpenHourOfParticularBranch[0].saturdayCloseTime, "HH:mm").format("hh:mm a");
                    }
                  } else {
                    returnDateMessages = "Office is closed on Saturday";
                  }
                  break;
              }

              if (
                pickupDateMessages === ""
                && pickupTimeMessages === ""
                && returnDateMessages === ""
                && returnTimeMessages === ""
                && minBookingMessage === ""
              ) {
                const alerMessage = "";
                changeTheDate(alerMessage);
              } else {
                setConfirmData({
                  title: `${pickupDateMessages} ${pickupTimeMessages} ${returnDateMessages} ${returnTimeMessages}`,
                  summary: 'Are you sure you want to proceed?',
                  isConfirm: (callback: any) => {
                    const alerMessage = `${pickupDateMessages} ${pickupTimeMessages} ${returnDateMessages} ${returnTimeMessages}`;
                    changeTheDate(alerMessage, callback);
                  }
                });

                setConfirmPopup(true);
              }

            }
            handleTenantError(null);
          })
          .catch((error) => {
            handleTenantError(error);
          })
      }
    } else {
      setConfirmPopup(true);
      setConfirmData({
        title: `We are closed on ${format(new Date(pickupDate), finalDateFormat.replace('DD', 'dd'))} and ${format(new Date(returnDate), finalDateFormat.replace('DD', 'dd'))}`,
        summary: 'Are you sure you want to proceed?',
        isConfirm: (callback: any) => {
          const alerMessage = `We are closed on ${format(new Date(pickupDate), finalDateFormat.replace('DD', 'dd'))} and ${format(new Date(returnDate), finalDateFormat.replace('DD', 'dd'))}`;
          changeTheDate(alerMessage, callback);
        }
      });
    }
  };

  const changeTheDate = (alerMessage: string, callback?: any) => {
    setPleaseWait(true)

    if (selectedVehicleClassId > 0 && selectBranchId === branchId) {
      let latestPickup = moment().format('YYYY-MM-DDTHH:mm');
      let latestReturn = moment().format('YYYY-MM-DDTHH:mm');
      if (pickupDate) latestPickup = moment(`${pickupDate}T${pickupTime}`).format('YYYY-MM-DDTHH:mm');
      if (returnDate) latestReturn = moment(`${returnDate}T${returnTime}`).format('YYYY-MM-DDTHH:mm');

      if (reservationId > 0) {
        getCarsWithReservation(reservationId, latestPickup, latestReturn, branchId, tenantId)
          .then((data) => {
            const selectedVehicles = data?.find((vehicleClass: any) => vehicleClass?.vehicleClassId === selectedVehicleClassId);

            if (selectedVehicles?.availableVehicles > 0) {
              setAvailableVehicle(data);
              getDataFromDate(
                pickupDate,
                pickupTime,
                returnDate,
                returnTime,
                alerMessage,
                branchId,
                pickupLocationId,
                returnLocationId,
                walkInCustomer
              );
              goToNextPage(1);
              callback && callback();
            } else {
              setConfirmData({
                title: `Between ${moment(latestPickup)?.format(dateFormat + " hh:mm A")} - ${moment(latestReturn)?.format(dateFormat + " hh:mm A")} dates selected vehicle is not available`,
                summary: '',
                confirmBtn: 'Ok',
                isConfirm: (callback: any) => {
                  callback();
                }
              });
              setConfirmPopup(true);
              setPleaseWait(false);
            }
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWait(false);
            setConfirmData({
              title: 'Warning',
              summary: error.response.data,
              confirmBtn: 'Ok',
              isConfirm: (callback: any) => {
                callback();
              }
            });

            setConfirmPopup(true);
            handleTenantError(error);
          });
      } else {
        getTheAvailableCarsOFBranch(latestPickup, latestReturn, branchId, tenantId)
          .then((data) => {
            const selectedVehicles = data?.find((vehicleClass: any) => vehicleClass?.vehicleClassId === selectedVehicleClassId);

            if (selectedVehicles?.availableVehicles > 0) {
              setAvailableVehicle(data);
              getDataFromDate(
                pickupDate,
                pickupTime,
                returnDate,
                returnTime,
                alerMessage,
                branchId,
                pickupLocationId,
                returnLocationId,
                walkInCustomer
              );
              goToNextPage(1);
              callback && callback();
            } else {
              setConfirmData({
                title: `Between ${moment(latestPickup)?.format(dateFormat + " hh:mm A")} - ${moment(latestReturn)?.format(dateFormat + " hh:mm A")} dates selected vehicle is not available`,
                summary: '',
                confirmBtn: 'Ok',
                isConfirm: (callback: any) => {
                  callback();
                }
              });
              setConfirmPopup(true);
              setPleaseWait(false);
            }
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWait(false);
            setConfirmData({
              title: 'Warning',
              summary: error.response.data,
              confirmBtn: 'Ok',
              isConfirm: (callback: any) => {
                callback();
              }
            });

            setConfirmPopup(true);
            handleTenantError(error);
          });
      }
    } else {
      getDataFromDate(
        pickupDate,
        pickupTime,
        returnDate,
        returnTime,
        alerMessage,
        branchId,
        pickupLocationId,
        returnLocationId,
        walkInCustomer
      );
      goToNextPage(1);
      setVehicleClassId(0);
      setSelectedVehiclesClass(null);
      callback && callback();
    }
  }

  const branchChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setBranchId(parseInt(e.target.value));

    const branch = branches?.find((item: any) => item?.id === parseInt(e.target.value));
    if (branch) {
      const offset = moment.tz(moment.tz.guess()).format('Z');
      const defaultTimeZone = `(GMT ${offset}) ${moment.tz.guess()} ${moment.tz(moment.tz.guess()).zoneAbbr()}`;

      const selectedBranchTimezone = branch?.timeZone;
      if (selectedBranchTimezone) {
        if (parseInt(selectedBranchTimezone) > 0) {
          const timeZoneData = timezoneOptions.find((item: any) => item.value === parseInt(selectedBranchTimezone));
          if (timeZoneData) {
            if (currentType === CurrentType.ADD) {
              const timeData = new Date().toLocaleString("en-US", {
                timeZone: timeZoneData?.label?.split(" ")[2]
              });

              setPickupTime(moment(timeData).format('HH:mm'));
              setReturnTime(moment(timeData).format('HH:mm'));

              const currentTimezoneDate = new Date(branchTimezone(timeZoneData?.label));
              setPickupDate(moment(currentTimezoneDate).format("YYYY-MM-DD"));
              setReturnDate(moment(currentTimezoneDate).add(1, 'day').format("YYYY-MM-DD"));
            }
            setFormattedCreatedAt(timeZoneData?.label);
          } else {
            if (currentType === CurrentType.ADD) {
              const timeData = new Date().toLocaleString("en-US", {
                timeZone: moment.tz.guess()
              });

              setPickupTime(moment(timeData).format('HH:mm'));
              setReturnTime(moment(timeData).format('HH:mm'));

              const currentTimezoneDate = new Date(branchTimezone(defaultTimeZone));
              setPickupDate(moment(currentTimezoneDate).format("YYYY-MM-DD"));
              setReturnDate(moment(currentTimezoneDate).add(1, 'day').format("YYYY-MM-DD"));
            }

            setFormattedCreatedAt(defaultTimeZone);
          }
        } else {
          if (currentType === CurrentType.ADD) {
            const timeData = new Date().toLocaleString("en-US", {
              timeZone: moment.tz.guess()
            });

            setPickupTime(moment(timeData).format('HH:mm'));
            setReturnTime(moment(timeData).format('HH:mm'));

            const currentTimezoneDate = new Date(branchTimezone(defaultTimeZone));
            setPickupDate(moment(currentTimezoneDate).format("YYYY-MM-DD"));
            setReturnDate(moment(currentTimezoneDate).add(1, 'day').format("YYYY-MM-DD"));
          }

          setFormattedCreatedAt(defaultTimeZone);
        }
      } else {
        setFormattedCreatedAt(defaultTimeZone);
      }
    }

    if (currentType === CurrentType.EDIT || currentType === CurrentType.ADD_FROM_QUOTES) {
      const locationId = branchs.find((item: any) => item.value === parseInt(e.target.value)).locationId;
      setPickupLocationId(locationId);
      setReturnLocationId(locationId);

      const selectedBranchLocation = pickupLocationOptionsOfParticularBranch?.find((item: any) => item?.value === parseInt(locationId));
      if (selectedBranchLocation) {
        setLocationFeeAmount(selectedBranchLocation?.locationFee);
        setTaxAmount(selectedBranchLocation?.tax);
        setMandatoryAdditionalChargesAmount(selectedBranchLocation?.mandatoryAdditionalCharges);
        setGovernmentTaxAmount(selectedBranchLocation?.governmentTax);
      } else {
        setLocationFeeAmount(0);
        setTaxAmount(0);
        setMandatoryAdditionalChargesAmount(0);
        setGovernmentTaxAmount(0);
      }
    }
  }


  return (
    <>
      <div className="w-full mt-2">
        <div className={`w-full pb-4`}>
          <div className="flex">
            <div className="mt-2 p-2 w-[50%]">
              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="w-full px-2">
                  <div className="grid grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Branch</label>
                        <select
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={branchId}
                          onChange={branchChange}
                        >
                          {
                            branchs?.map((item: any) => {
                              return (
                                <option
                                  key={item.value}
                                  value={item.value}
                                >
                                  {item.label}
                                </option>
                              );
                            })
                          }
                        </select>
                      </div>
                    </div>

                  </div>

                  <div className="grid grid-cols-2 gap-6 mt-[16px]">
                    <div className="space-y-4">
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Pickup Location</label>
                        <select
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={pickupLocationId}
                          onChange={(e) => {
                            setPickupLocationId(parseInt(e.target.value));

                            const selectedBranchLocation = pickupLocationOptionsOfParticularBranch?.find((item: any) => item?.value === parseInt(e.target.value));
                            if (selectedBranchLocation) {
                              setLocationFeeAmount(selectedBranchLocation?.locationFee);
                              setTaxAmount(selectedBranchLocation?.tax);
                              setMandatoryAdditionalChargesAmount(selectedBranchLocation?.mandatoryAdditionalCharges);
                              setGovernmentTaxAmount(selectedBranchLocation?.governmentTax);
                            } else {
                              setLocationFeeAmount(0);
                              setTaxAmount(0);
                              setMandatoryAdditionalChargesAmount(0);
                              setGovernmentTaxAmount(0);
                            }
                          }}
                        >
                          {
                            pickupLocationOptionsOfParticularBranch?.map((item: any, index: number) => {
                              return (
                                <option
                                  key={index}
                                  value={item.value}
                                >
                                  {item.label}
                                </option>
                              );
                            })
                          }
                        </select>
                      </div>
                    </div>
                    <div className="space-y-4">
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Return Location</label>
                        <select
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={returnLocationId}
                          onChange={(e) => setReturnLocationId(parseInt(e.target.value))}
                        >
                          {
                            returnLocationOptionsOfParticularBranch?.map((item: any, index: number) => {
                              return (
                                <option
                                  key={index}
                                  value={item.value}
                                >
                                  {item.label}
                                </option>
                              );
                            })
                          }
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-6 mt-[16px]">
                    <div className="space-y-4">
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Pickup Date</label>
                        <CustomFormatDatePicker
                          value={pickupDate}
                          onChange={(value) => {
                            setPickupDate(value)
                            if (new Date(value) >= new Date(returnDate)) {
                              setReturnDate(moment(value).add(1, 'day').format('YYYY-MM-DD'))
                            }
                          }}
                          dateFormat={finalDateFormat}
                          required={true}
                        />
                      </div>

                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Return Date</label>
                        <CustomFormatDatePicker
                          value={returnDate}
                          onChange={setReturnDate}
                          dateFormat={finalDateFormat}
                          minDate={pickupDate}
                          required={true}
                        />
                      </div>
                    </div>

                    <div className="space-y-4">
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Pickup Time</label>
                        <input
                          type="time"
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={pickupTime}
                          onChange={(e) => {
                            setPickupTime(e.target.value)
                          }}
                          required
                        />
                      </div>

                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Return Time</label>
                        <input
                          type="time"
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={returnTime}
                          onChange={(e) => setReturnTime(e.target.value)}
                          required
                        />

                        {
                          returnTimeMessage && (
                            <ul className="text-xs text-red-500 m-1">
                              <li>{returnTimeMessage}</li>
                            </ul>
                          )
                        }

                        {
                          minBookingMessage && (
                            <ul className="text-xs text-red-500 m-1">
                              <li>{minBookingMessage}</li>
                            </ul>
                          )
                        }
                      </div>
                    </div>
                  </div>

                  <div className="mt-[16px]">
                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Walk in Customer?</label>
                    <RadioGroup
                      row
                      value={walkInCustomer ? "Yes" : "No"}
                      onChange={(e) => setWalkInCustomer(e.target.value === "Yes" ? true : false)}
                    >
                      <FormControlLabel

                        value="Yes" control=
                        {<Radio
                          sx={{
                            color: "gray",
                            "&.Mui-checked": {
                              color: "#167AC3",
                            },
                          }}
                        />} label="Yes"
                        sx={{
                          color: themeStyles.form.labelTextColor
                        }}
                      />
                      <FormControlLabel value="No" control={
                        <Radio
                          sx={{
                            color: "gray",
                            "&.Mui-checked": {
                              color: "#167AC3",
                            },
                          }}
                        />} label="No"
                        sx={{
                          color: themeStyles.form.labelTextColor
                        }}
                      />
                    </RadioGroup>
                  </div>
                  <div className="flex gap-4 mt-6">
                    <Button variant="contained"
                      sx={{
                        backgroundColor: colorConfigs.btn.main.bg
                      }}
                      type="submit">
                      Next
                    </Button>

                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}